import moment from "moment";
import auth from "../../server/auth";
import location from "../../server/location";

const layoutStore = {
  namespaced: true,
  state: () => ({
    alert: false,
    currentUser: {}
  }),
  mutations: {
    async setAlert(state, alert) {
      state.alert = alert;
    },
    setUser: (state, user) => (state.currentUser = user)
  },
  actions: {
    showAlertSuccess({ commit, dispatch }, data = { message: "Success!" }) {
      commit("setAlert", {
        type: "success",
        message: data.message
      });
      setTimeout(() => {
        dispatch("hideAlert");
      }, 5000);
    },
    showAlertError({commit, dispatch, state}, {message}) {
      commit("setAlert", {
        type: "error",
        message
      });
      if (message == "Error!") {
        setTimeout(() => {
          if (state.alert && state.alert.message == "Error!") {
            dispatch("hideAlert");
          }
        }, 5000);
      }
    },
    async fetchCurrentUser({ commit }) {
      const currentUser = await auth.getCurrentUser();
      if (currentUser !== null) {
        commit("setUser", currentUser);
        location.get(currentUser.data.locationId).then(location => {
          commit("setLocation", location);
        });
      }
    }
  },
  getters: {
    user: state => state.currentUser,
    getCurrentAdjustedDateTime: (state, getters, rootState) => () => {
      const currentMomentUtc = moment(
        moment
          .utc()
          .format()
          .slice(0, -1)
      );
      const curentLocation = rootState.session.location;
      const currentMomentAdjusted = currentMomentUtc.add(
        curentLocation?.timeZoneHoursShift,
        "hours"
      );
      return currentMomentAdjusted.toDate();
    }
  }
};

export default layoutStore;
